import React from "react";
import "../styles/StoreInfo.css";

function StoreInfo({ shop }) {
  return (
    <div className="store-info__container">
      <h1 className="store-info__heading">{shop?.storeName}</h1>
      <span>{shop.storeDescription}</span>

      <div className="store-info__section">
        <h2 className="store-info__heading">Address</h2>
        <p>
          {shop.storeAddress?.address}, {shop.storeAddress?.city},{" "}
          {shop.storeAddress?.zipcode}
        </p>
      </div>

      <div className="store-info__section">
        <h2 className="store-info__heading">Contact</h2>
        {shop.storePhone?.map((phone, index) => (
          <p key={index}>📞 {phone}</p>
        ))}

        {shop.storeEmail && <p>✉️ {shop.storeEmail}</p>}
      </div>

      <div className="store-info__section">
        <h2 className="store-info__heading">Opening Hours</h2>
        <ul className="store-info__list">
          {[
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday",
            "sunday",
          ].map((day) => (
            <li key={day} className="store-info__list-item">
              {day.charAt(0).toUpperCase() + day.slice(1)}:{" "}
              {shop.openingHours?.[day]?.join(", ") || "Closed"}
            </li>
          ))}
        </ul>
      </div>

      <div className="store-info__section">
        <h2 className="store-info__heading">Store Info</h2>
        <p>
          Payment Methods: {shop.paymentMethods?.join(", ") || "Not specified"}
        </p>
        <p>
          Return Policy:{" "}
          {shop.returnPolicyUrl ? (
            <a href={shop.returnPolicyUrl} className="store-info__link">
              {shop.returnPolicyUrl}
            </a>
          ) : (
            "Not provided"
          )}
        </p>
        <p>Privacy: {shop.privacy || "Not specified"}</p>
        <p>Tax ID: {shop.taxId || "Not specified"}</p>
        <p>KRS: {shop.krs || "Not specified"}</p>
      </div>

      <div className="store-info__section">
        <h2 className="store-info__heading">Rating</h2>
        <p>Average: {shop.rating?.average || "No ratings yet"}</p>
        <p>Total Reviews: {shop.rating?.totalReviews || "No reviews yet"}</p>
      </div>
    </div>
  );
}

export default StoreInfo;
